"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getSignedUrlQuery = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getSignedUrlQuery = `
    query GetSignedUrl($organisationId: String!, $bucketKey: String!, $action: S3Action!) {
      getS3SignedUrl(organisationId: $organisationId, bucketKey: $bucketKey, action: $action)
    }
`;
exports.getSignedUrlQuery = getSignedUrlQuery;

var _default = (0, _graphqlTag.default)`${getSignedUrlQuery}`;

exports.default = _default;